
const TYPE_MAPPING = ['score', 'quantity', 'execution_level'];

export const transform = ({
							  id,
							  name,
							  timeframe,
							  type,
							  passfail,
							  desc,
							  isexpired


}) => (
	{
		id: id,
		name: name,
		timeframe: timeframe,
		type: TYPE_MAPPING.find((_, i) => [type.isScoreRequiredField, type.isQuantityRequiredField, type.isExecutionLevelRequiredField][i]) || 'null',
		boolean: passfail,
		desc: desc,
		isexpired:isexpired,
	}
);
